<template>
    <el-dialog
        title="新增"
        class="leader-dialog add-dialog"
        width="85%"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :visible.sync="addVisible"
        @close="closeDialog"
    >
        <el-form
            class="leader-style-form"
            :model="searchForm"
            ref="searchForm"
            :inline="true"
            :rules="searchFormRule"
        >
            <el-row>
                <el-col :span="6">
                    <el-form-item label="部门" prop="target_unit_id">
                        <el-select v-model="searchForm.target_unit_id">
                            <el-option
                                v-for="item in departments"
                                :key="item.target_unit_id"
                                :label="item.target_unit_name"
                                :value="item.target_unit_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="时间" prop="show_month">
                        <el-date-picker
                            v-model="searchForm.show_month"
                            type="month"
                            :picker-options="disableDate"
                            placeholder="请选择日期"
                            value-format="yyyy-MM"
                            format="yyyy-MM"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="基本电费(元)" prop="base_total_price" style="margin-left: -4%">
                        <el-input
                            v-model="searchForm.base_total_price"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                            placeholder="请输入基本电费"
                            maxlength="20"
                            @blur="inputTotalPrice"
                        ></el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :span="4">
                    <el-form-item style="float: right">
                        <el-button
                            size="small"
                            class="btn-class"
                            @click="searchData"
                        >查询
                        </el-button
                        >
                        <el-button v-if="searchForm.tableList && searchForm.tableList.length" size="small" class="btn-class" @click="saveData"
                        >保存
                        </el-button
                        >
                    </el-form-item>
                </el-col>
            </el-row>
            
            
            <el-row :gutter="24">
                <el-col :span="5">
                    <el-form-item label="修正值" prop="revise" style="margin-left: -5%">
                        <el-input
                            v-model="searchForm.revise"
                            placeholder="请输入修正值"
                            maxlength="20"
                            style="width: 12vw"
                            v-Int.float
                            @blur="inputRevise"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="线损(kWh)" prop="line_loss_total_power" style="margin-left: 5%">
                        <el-input
                            v-model="searchForm.line_loss_total_power"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                            placeholder="请输入线损"
                            maxlength="20"
                            style="width: 13vw"
                            @blur="inputLineLoss"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="10" :offset="1">
                    <el-form-item
                        label="修正原因"
                        prop="revise_reason"
                        label-width="100px"
                        style="width: 30vw;margin-left: -4%"
                        class="my-textarea"
                    >
                        <el-input
                            v-model="searchForm.revise_reason"
                            placeholder="请输入修正原因"
                            type="textarea"
                            :rows="2"
                            maxlength="200"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <div
                style="width: 100%;height: 40px;color: red;padding: 0 40px;text-align: center;margin-top: 20px"
            >
                {{
                    warning && warning.length > 0 ? warning : ""
                }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;光伏本月剩余分摊比例：{{
                    pv_rate_surplus
                }}%
            </div>
            <el-table
                border
                :data="searchForm.tableList"
                class="leader-style-table myTable"
                show-summary
                :summary-method="getSummaries"
                :key="certinfoKey"
                :span-method="objectSpanMethod"
            >
                <el-table-column label="序号" width="50px">
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="用电类别"
                    prop="electric_charge_dtl_name"
                ></el-table-column>
                <el-table-column
                    label="示数类型"
                    prop="code_name"
                    width="100px"
                ></el-table-column>
                <el-table-column
                    label="开始时间"
                    prop="from_date"
                ></el-table-column>
                <el-table-column
                    label="结束时间"
                    prop="to_date"
                ></el-table-column>
                <el-table-column label="使用电量" prop="active_power">
                    <template slot-scope="scope">
                        <template v-if="scope.row.editActive">
                            <el-input
                                v-model="scope.row[scope.column.property]"
                                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                                maxlength="20"
                                placeholder="请输入电量"
                                @blur="inputActive($event, scope.row)"
                            ></el-input>
                        </template>
                        <template v-else>
                            <span>{{ scope.row[scope.column.property] }}</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="光伏占比" prop="pv_rate" width="200px">
                    <template slot-scope="scope">
                        <template v-if="scope.row.editPv_rate">
                            <el-form-item
                                :prop="'tableList.' + scope.$index + '.pv_rate'"
                            >
                                <el-input
                                    v-model="scope.row[scope.column.property]"
                                    type="number"
                                    maxlength="20"
                                    placeholder="请输入光伏占比"
                                    clearable
                                    @blur="inputPvRate($event, scope.row)"
                                >
                                    <template slot="append" class="my_append"
                                        >%</template
                                    ></el-input
                                >
                            </el-form-item>
                        </template>
                        <template v-else>
                            <template
                                v-if="
                                    scope.row.electric_charge_dtl_id ==
                                        'guangfu_fentan'
                                "
                            >
                                <el-form-item
                                    :prop="
                                        'tableList.' + scope.$index + '.pv_rate'
                                    "
                                >
                                    <el-input
                                        v-model="
                                            scope.row[scope.column.property]
                                        "
                                        type="number"
                                        maxlength="20"
                                        disabled
                                    >
                                        <template
                                            slot="append"
                                            class="my_append"
                                            >%</template
                                        ></el-input
                                    >
                                </el-form-item>
                            </template>
                            <template v-else>
                                <span>{{
                                    scope.row[scope.column.property]
                                }}</span>
                            </template>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    label="光伏分摊电量(kWh)"
                    prop="pv_power"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    label="占比"
                    prop="rate"
                    width="100px"
                ></el-table-column>

                <el-table-column label="单价" prop="schedule_price">
                    <template slot-scope="scope">
                        <el-form-item
                            :prop="
                                'tableList.' + scope.$index + '.schedule_price'
                            "
                            :rules="[
                                {
                                    required:
                                        scope.row.electric_charge_dtl_id ==
                                        'bei_guowang'
                                            ? false
                                            : true,
                                    message: '请输入单价',
                                    trigger: 'blur'
                                }
                            ]"
                        >
                            <template v-if="scope.row.editSchedule_price">
                                <el-input
                                    v-model="scope.row[scope.column.property]"
                                    type="number"
                                    maxlength="20"
                                    placeholder="请输入单价"
                                    @blur="inputPrice($event, scope.row)"
                                ></el-input>
                            </template>
                            <template v-else>
                                <el-input
                                    v-model="scope.row[scope.column.property]"
                                    type="number"
                                    maxlength="20"
                                    disabled
                                ></el-input>
                            </template>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column
                    label="电费"
                    prop="schedule_money"
                ></el-table-column>
            </el-table>
        </el-form>

        <!-- <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                class="btn-class leader-common-button"
                @click="saveData"
                >保存</el-button
            >
        </span>-->
    </el-dialog>
</template>
<script>
import * as api from "@/http/api.js";
import dayjs from "dayjs";
export default {
    props: {
        addVisible: {
            type: Boolean
        }
    },
    data() {
        return {
            sysDate: "",
            warning: "",
            pv_rate_surplus: "", //光伏本月剩余分摊比例
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(
                                dayjs(new Date(this.sysDate))
                                    .subtract(1, "days")
                                    .format("YYYY-MM")
                            ).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            searchForm: {
                revise: 0, //修正值
                revise_reason: "", //修正原因
                target_unit_id: "", //部门id
                show_month: "", //月份
                base_total_price: "", //基本电费
                line_loss_total_power: "", //线损
                tableList: []
            },
            searchFormRule: {
                revise: [
                    {
                        required: true,
                        message: "修正值不能为空",
                        trigger: "blur"
                    }
                ],
                target_unit_id: [
                    {
                        required: true,
                        message: "部门不能为空",
                        trigger: "change"
                    }
                ],
                show_month: [
                    {
                        required: true,
                        message: "时间不能为空",
                        trigger: "change"
                    }
                ],
                base_total_price: [
                    {
                        required: true,
                        message: "请输入基本电费",
                        trigger: "blur"
                    }
                ],
                line_loss_total_power: [
                    {
                        required: true,
                        message: "请输入线损",
                        trigger: "blur"
                    }
                ],
                // revise_reason: [
                //      {
                //         required: true,
                //         message: "请输入修正原因",
                //         trigger: "blur"
                //     }
                // ]
            },
            // 部门列表
            departments: [],
            certinfoKey: true
        };
    },
    watch: {
        addVisible: {
            handler: function(newVal) {
                this.getTargetUnitElec();
                // 获取系统时间
                this.getSysDate();
                this.searchForm.revise = 0;
                this.searchForm.revise_reason = "";
                this.searchForm.target_unit_id = "";
                this.searchForm.show_month = "";
                this.searchForm.base_total_price = "";
                this.searchForm.line_loss_total_power = "";
                this.searchForm.tableList = "";
            },
            immediate: true
        }
    },
    created() {},
    methods: {
        // 获取系统时间
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res) {
                    this.searchForm.show_month = dayjs(
                        new Date(res.bus_json.sysdate3)
                    )
                        .subtract(1, "days")
                        .format("YYYY-MM");
                    this.sysDate = res.bus_json.sysdate3;
                }
            });
        },
        getTargetUnitElec() {
            api.getTargetUnitElec().then(res => {
                if (res && res.error_code == 0) {
                    this.departments = res.bus_json;
                }
            });
        },
        searchData() {
            this.$refs["searchForm"].validate(valid => {
                if(!valid){
                    return;
                }
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                api.getDefaultCalculate({
                    show_month: this.searchForm.show_month,
                    target_unit_id: this.searchForm.target_unit_id,
                    base_total_price: this.searchForm.base_total_price,
                    line_loss_total_power: this.searchForm.line_loss_total_power
                }).then(res => {
                    if (res && res.error_code == 0) {
                        // loading.close();
                        const tempArr = res.bus_json.dtlInfos;
                        this.warning = res.bus_json.warning;
                        this.pv_rate_surplus = res.bus_json.pv_rate_surplus; // 光伏本月剩余分摊比例
                        tempArr.forEach(item => {
                            item["rate"] = "-";
                            item["editSchedule_price"] = true;
                            item["editPv_rate"] = true;
                            item["editActive"] = false;
                        });

                        let my1 = {
                            electric_charge_dtl_id: "base_guowang",
                            electric_charge_dtl_name: "国网公摊费用(基本电费)",
                            code_name: "-",
                            from_date: "-",
                            to_date: "-",
                            active_power: "-",
                            pv_rate: "-",
                            pv_power: "-",
                            rate: res.bus_json.unit_base_price_rate,
                            schedule_price: res.bus_json.base_total_price,
                            schedule_money: res.bus_json.base_total_money,
                            editPv_rate: false, //光伏占比是否可输入
                            editSchedule_price: false, // 新增的字段
                            editActive: false //新增的字段，判断电量是否可以输入
                        };
                        let my2 = {
                            electric_charge_dtl_id: "line_guowang",
                            electric_charge_dtl_name: "国网公摊费用(线损)",
                            code_name: "-",
                            from_date: "-",
                            to_date: "-",
                            active_power: res.bus_json.line_loss_power,
                            pv_rate: "-",
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: res.bus_json.line_loss_power_rate,
                            schedule_price: res.bus_json.line_loss_power_price,
                            schedule_money: res.bus_json.line_loss_total_money,
                            editSchedule_price: true, // 新增的字段
                            editActive: false //新增的字段，判断电量是否可以输入
                        };
                        let my21 = {
                            electric_charge_dtl_id: "jian_guowang",
                            electric_charge_dtl_name: "企业内部公共用电公摊费用",
                            code_name: "尖",
                            from_date: "-",
                            to_date: "-",
                            active_power: res.bus_json.common_sharp,
                            pv_rate: "-",
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: res.bus_json.common_sharp_rate,
                            schedule_price: res.bus_json.common_sharp_price,
                            schedule_money: res.bus_json.common_sharp_total_money,
                            editSchedule_price: true, // 新增的字段
                            editActive: false //新增的字段，判断电量是否可以输入
                        };
                        let my3 = {
                            electric_charge_dtl_id: "feng_guowang",
                            electric_charge_dtl_name: "企业内部公共用电公摊费用",
                            code_name: "峰",
                            from_date: "-",
                            to_date: "-",
                            active_power: res.bus_json.common_peak,
                            pv_rate: "-",
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: res.bus_json.common_peak_rate,
                            schedule_price: res.bus_json.common_peak_price,
                            schedule_money: res.bus_json.common_peak_total_money,
                            editSchedule_price: true, // 新增的字段
                            editActive: false //新增的字段，判断电量是否可以输入
                        };
                        let my4 = {
                            electric_charge_dtl_id: "ping_guowang",
                            electric_charge_dtl_name: "企业内部公共用电公摊费用",
                            code_name: "平",
                            from_date: "-",
                            to_date: "-",
                            active_power: res.bus_json.common_off,
                            pv_rate: "-",
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: res.bus_json.common_off_rate,
                            schedule_price: res.bus_json.common_off_price,
                            schedule_money: res.bus_json.common_off_total_money,
                            editSchedule_price: true, // 新增的字段
                            editActive: false //新增的字段，判断电量是否可以输入
                        };
                        let my5 = {
                            electric_charge_dtl_id: "gu_guowang",
                            electric_charge_dtl_name: "企业内部公共用电公摊费用",
                            code_name: "谷",
                            from_date: "-",
                            to_date: "-",
                            active_power: res.bus_json.common_shoulder,
                            pv_rate: "-",
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: res.bus_json.common_shoulder_rate,
                            schedule_price: res.bus_json.common_shoulder_price,
                            schedule_money:
                            res.bus_json.common_shoulder_total_money,
                            editSchedule_price: true, // 新增的字段
                            editActive: false //新增的字段，判断电量是否可以输入
                        };
                        let my6 = {
                            electric_charge_dtl_id: "bei_guowang",
                            electric_charge_dtl_name: "备用电源(发电)",
                            code_name: "-",
                            from_date: "-",
                            to_date: "-",
                            active_power: res.bus_json.back_power,
                            pv_rate: "-",
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: "-",
                            schedule_price: res.bus_json.back_price,
                            schedule_money: res.bus_json.back_total_money,
                            editSchedule_price: true, // 新增的字段
                            editActive: true //新增的字段，判断电量是否可以输入
                        };
                        let my7 = {
                            electric_charge_dtl_id: "lingshou_guowang",
                            electric_charge_dtl_name: "零售电费",
                            code_name: "-",
                            from_date: "-",
                            to_date: "-",
                            active_power: res.bus_json.retail_power, // 待修改 电量
                            pv_rate: "-",
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: "-",
                            schedule_price: res.bus_json.retail_price, // 待修改 单价
                            schedule_money: parseFloat(
                                res.bus_json.retail_money
                            ).toFixed(4), // 待修改 电费
                            editSchedule_price: true, // 新增的字段
                            editActive: true //新增的字段，判断电量是否可以输入
                        };
                        let my8 = {
                            electric_charge_dtl_id: "guangfu_fentan",
                            electric_charge_dtl_name: "光伏分摊电量",
                            code_name: "-",
                            from_date: "-",
                            to_date: "-",
                            active_power: parseFloat(
                                res.bus_json.pv_power_sum
                            ).toFixed(4), // 待修改 电量
                            pv_rate: res.bus_json.pv_rate_sum,
                            pv_power: "-",
                            editPv_rate: false, //光伏占比是否可输入
                            rate: "-",
                            schedule_price: res.bus_json.pv_price, // 待修改 单价
                            schedule_money: parseFloat(
                                res.bus_json.pv_power_money
                            ).toFixed(4), // 待修改 电费
                            editSchedule_price: true, // 新增的字段
                            editActive: false //新增的字段，判断电量是否可以输入
                        };
                        this.searchForm.base_total_price =
                            res.bus_json.base_total_price;
                        this.searchForm.line_loss_total_power =
                            res.bus_json.line_loss_total_power;
                        let data1 = [my1, my2, my21, my3, my4, my5, my6, my7, my8];
                        this.searchForm.tableList = [...tempArr, ...data1];

                        this.searchForm.tableList.forEach(item => {
                            // 国网公摊费用（线损）
                            if (
                                item.electric_charge_dtl_id == "line_guowang" ||
                                item.electric_charge_dtl_id == "jian_guowang" ||
                                item.electric_charge_dtl_id == "feng_guowang" ||
                                item.electric_charge_dtl_id == "ping_guowang" ||
                                item.electric_charge_dtl_id == "gu_guowang"
                            ) {
                                let sum = 0;

                                // 将变比转成float类型 做计算
                                let new_rate = parseFloat(
                                    item.rate.slice(0, item.rate.length - 1)
                                );
                                // 将电量转化为float
                                let active_float = parseFloat(item.active_power);
                                sum =
                                    (new_rate *
                                        item.schedule_price *
                                        active_float) /
                                    100;
                                item.schedule_money = sum.toFixed(4);
                            } else if (
                                item.electric_charge_dtl_id == "base_guowang"
                            ) {
                                // 将变比转成float类型 做计算
                                let new_rate = parseFloat(
                                    item.rate.slice(0, item.rate.length - 1)
                                );
                                item.schedule_money =
                                    (new_rate * item.schedule_price) / 100;
                            } else {
                                let sum = 0;
                                sum = item.active_power * item.schedule_price;
                                item.schedule_money = sum.toFixed(4);
                            }
                        });
                    }
                    loading.close();
                });
            });
            
        },
        // 保存
        saveData() {
            this.$refs["searchForm"].validate(valid => {
                if (valid) {
                    let params = {};
                    let T = [];
                    let total_money = 0;
                    console.log("haha: ", this.searchForm.tableList);
                    this.searchForm.tableList.forEach(item => {
                        if (item.electric_charge_dtl_id == "base_guowang") {
                            params["unit_base_price_rate"] = item.rate.slice(
                                0,
                                item.rate.length - 1
                            );
                            params["unit_base_price"] = item.schedule_price;
                            params["base_total_money"] = item.schedule_money;
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            item.electric_charge_dtl_id == "line_guowang"
                        ) {
                            params["line_loss_power"] = item.active_power;
                            params["line_loss_power_rate"] = item.rate.slice(
                                0,
                                item.rate.length - 1
                            );
                            params["line_loss_power_price"] =
                                item.schedule_price;
                            params["line_loss_total_money"] =
                                item.schedule_money;
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            item.electric_charge_dtl_id == "jian_guowang"
                        ) {
                            params["common_sharp"] = item.active_power;
                            params["common_sharp_rate"] = item.rate.slice(
                                0,
                                item.rate.length - 1
                            );
                            params["common_sharp_price"] = item.schedule_price;
                            params["common_sharp_total_money"] =
                                item.schedule_money;
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            item.electric_charge_dtl_id == "feng_guowang"
                        ) {
                            params["common_peak"] = item.active_power;
                            params["common_peak_rate"] = item.rate.slice(
                                0,
                                item.rate.length - 1
                            );
                            params["common_peak_price"] = item.schedule_price;
                            params["common_peak_total_money"] =
                                item.schedule_money;
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            item.electric_charge_dtl_id == "ping_guowang"
                        ) {
                            params["common_off"] = item.active_power;
                            params["common_off_rate"] = item.rate.slice(
                                0,
                                item.rate.length - 1
                            );
                            params["common_off_price"] = item.schedule_price;
                            params["common_off_total_money"] =
                                item.schedule_money;
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            item.electric_charge_dtl_id == "gu_guowang"
                        ) {
                            params["common_shoulder"] = item.active_power;
                            params["common_shoulder_rate"] = item.rate.slice(
                                0,
                                item.rate.length - 1
                            );
                            params["common_shoulder_price"] =
                                item.schedule_price;
                            params["common_shoulder_total_money"] =
                                item.schedule_money;
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            item.electric_charge_dtl_id == "bei_guowang"
                        ) {
                            params["back_power"] = item.active_power;
                            params["back_price"] = item.schedule_price;
                            params["back_total_money"] = item.schedule_money;
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            // 零售电费
                            item.electric_charge_dtl_id == "lingshou_guowang"
                        ) {
                            params["retail_power"] = item.active_power; // 待修改
                            params["retail_price"] = item.schedule_price; // 待修改
                            params["retail_money"] = item.schedule_money; // 待修改
                            total_money += parseFloat(item.schedule_money);
                        } else if (
                            // 零售电费
                            item.electric_charge_dtl_id == "guangfu_fentan"
                        ) {
                            params["pv_power_sum"] = item.active_power; // 光伏电量
                            params["pv_rate_sum"] = item.pv_rate; // 光伏占比和
                            params["pv_price"] = item.schedule_price; // 单价
                            params["pv_power_money"] = item.schedule_money; // 电费
                            total_money += parseFloat(item.schedule_money);
                        } else {
                            T.push(item);
                            total_money += parseFloat(item.schedule_money);
                        }
                    });
                    params["dtlInfos"] = T;
                    params["show_month"] = this.searchForm.show_month;
                    params["target_unit_id"] = this.searchForm.target_unit_id;
                    params[
                        "base_total_price"
                    ] = this.searchForm.base_total_price;
                    params[
                        "line_loss_total_power"
                    ] = this.searchForm.line_loss_total_power;
                    params[
                        "electric_charge_id"
                    ] = this.searchForm.electric_charge_id;
                    params["total_money"] = total_money;
                    params["revise"] = this.searchForm.revise;
                    params["revise_reason"] = this.searchForm.revise_reason;

                    // 接口调用
                    api.saveElectricChargeInfo(params).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.addVisible = false;
                            this.$emit("addComplete");
                        }
                    });
                }
            });
        },
        // 修正值输入
        inputRevise(event) {
            // 重新渲染el-table
            this.certinfoKey = !this.certinfoKey;
            this.$forceUpdate();
        },
        // 查询中的电费输入
        inputTotalPrice(event) {
            this.searchForm.tableList &&
                this.searchForm.tableList.forEach(item => {
                    if (item.electric_charge_dtl_id == "base_guowang") {
                        item.schedule_price = event.target.value;

                        // 将变比转成float类型 做计算
                        let new_rate = parseFloat(
                            item.rate.slice(0, item.rate.length - 1)
                        );
                        item.schedule_money =
                            (new_rate * item.schedule_price) / 100;
                    }
                });
        },
        // 查询中的线损输入
        inputLineLoss(event) {
            this.searchForm.tableList &&
                this.searchForm.tableList.forEach(item => {
                    if (item.electric_charge_dtl_id == "line_guowang") {
                        item.active_power = event.target.value;
                        let sum = 0;
                        // 将变比转成float类型 做计算
                        let new_rate = parseFloat(
                            item.rate.slice(0, item.rate.length - 1)
                        );
                        // 将电量转化为float
                        let active_float = parseFloat(item.active_power);
                        sum =
                            (new_rate * item.schedule_price * active_float) /
                            100;
                        item.schedule_money = sum.toFixed(4);
                    }
                });
        },
        // 光伏占比输入
        inputPvRate(event, param) {
            let guangfu_dianliang = 0; // 光伏电量
            let guangfu_zhanbi = 0; // 光伏占比
            if (param.pv_rate == "") param.pv_rate = 0;
            this.searchForm.tableList.forEach(item => {
                if (
                    item.electric_charge_dtl_id == "base_guowang" ||
                    item.electric_charge_dtl_id == "line_guowang" ||
                    item.electric_charge_dtl_id == "feng_guowang" ||
                    item.electric_charge_dtl_id == "ping_guowang" ||
                    item.electric_charge_dtl_id == "gu_guowang" ||
                    item.electric_charge_dtl_id == "bei_guowang" ||
                    item.electric_charge_dtl_id == "lingshou_guowang" ||
                    item.electric_charge_dtl_id == "guangfu_fentan"
                ) {
                    return;
                } else {
                    item.pv_power =
                        (parseFloat(item.active_power) *
                            parseFloat(item.pv_rate)) /
                        100;
                    guangfu_dianliang += item.pv_power;
                    guangfu_zhanbi += parseFloat(item.pv_rate);
                }
            });
            this.searchForm.tableList.forEach(item => {
                if (item.electric_charge_dtl_id == "guangfu_fentan") {
                    item.schedule_money =
                        guangfu_dianliang * parseFloat(item.schedule_price);
                    item.active_power = guangfu_dianliang.toFixed(4);
                    item.pv_rate = guangfu_zhanbi;
                }
            });
        },
        // 单价输入
        inputPrice(event, param) {
            this.searchForm.tableList &&
                this.searchForm.tableList.forEach(item => {
                    // 国网公摊费用（线损）
                    if (
                        item.electric_charge_dtl_id ==
                            param.electric_charge_dtl_id &&
                        (item.electric_charge_dtl_id == "line_guowang" ||
                            item.electric_charge_dtl_id == "feng_guowang" ||
                            item.electric_charge_dtl_id == "ping_guowang" ||
                            item.electric_charge_dtl_id == "gu_guowang")
                    ) {
                        let sum = 0;

                        // 将变比转成float类型 做计算
                        let new_rate = parseFloat(
                            item.rate.slice(0, item.rate.length - 1)
                        );
                        // 将电量转化为float
                        let active_float = parseFloat(item.active_power);
                        sum =
                            (new_rate * item.schedule_price * active_float) /
                            100;
                        item.schedule_money = sum;
                    } else if (
                        item.electric_charge_dtl_id ==
                        param.electric_charge_dtl_id
                    ) {
                        let sum = 0;
                        sum = item.active_power * item.schedule_price;
                        item.schedule_money = sum;
                    }
                });
            // // 重新渲染el-table
            // this.certinfoKey = !this.certinfoKey;
            // this.$forceUpdate();
        },
        // 电量输入
        inputActive(event, param) {},
        // 合计
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 1) {
                    sums[index] = "合计";
                    return;
                }
                if (index == 10) {
                    const values =
                        data && data.map(item => Number(item[column.property]));
                    if (values && !values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += parseFloat(this.searchForm.revise); // 总和需要加上修正值
                        sums[index] = parseFloat(sums[index]).toFixed(4);
                    } else {
                        sums[index] = "N/A";
                    }
                }
            });

            return sums;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            return;
            if (columnIndex == 1) {
                if (rowIndex == this.searchForm.tableList.length - 4) {
                    return {
                        rowspan: 3,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 1,
                        colspan: 1
                    };
                }
            }
        },
        closeDialog() {
            this.addVisible = false;
            this.$emit("update:addVisible", this.addVisible);
        }
    }
};
</script>
<style lang="scss">
.add-dialog {
    ::v-deep(.cell .el-form-item) {
        margin-bottom: 0px !important;
    }
    .my-textarea {
        display: flex !important;
        .el-form-item__content {
            width: 100%;
        }
    }
}
.el-input-group__append {
    width: 2rem !important;
    line-height: 2rem !important;
    border-width: 0px;
}
</style>
<style lang="scss" scoped></style>
